var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33335 29.3346V14.668M2.66669 17.3346V26.668C2.66669 28.1407 3.86059 29.3346 5.33335 29.3346H23.235C25.2093 29.3346 26.8883 27.8942 27.1885 25.9429L28.6244 16.6095C28.9972 14.1865 27.1225 12.0013 24.6709 12.0013H20C19.2636 12.0013 18.6667 11.4043 18.6667 10.668V5.95575C18.6667 4.13996 17.1947 2.66797 15.3789 2.66797C14.9458 2.66797 14.5533 2.92303 14.3774 3.3188L9.68527 13.8762C9.47127 14.3577 8.99377 14.668 8.46686 14.668H5.33335C3.86059 14.668 2.66669 15.8619 2.66669 17.3346Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.37f5c5ba530f268dd7faa159c856f01c.svg";
export { ForwardRef as ReactComponent };